import { render, staticRenderFns } from "./SortBar.vue?vue&type=template&id=86383536&"
import script from "./SortBar.vue?vue&type=script&lang=js&"
export * from "./SortBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports